// Shared design tokens for the landing page.
// Keep every color/spacing decision here so a change lands in one place.

export const c = {
  bg: "#FEFEFE",
  bgSoft: "#FBFBFD",
  bgTint: "#F6F7FE",
  ink: "#2C2B2A",
  inkSoft: "#4e5860",
  inkMuted: "#adadad",
  purple: "#8491F7",
  purpleDeep: "#5C6BE8",
  purpleInk: "#4C59D8",
  teal: "#D7E8F4",
  white: "#FFFFFF",
  line: "rgba(44,43,42,0.09)",
  lineStrong: "rgba(44,43,42,0.12)",
};

export const mono = "'IBM Plex Mono', ui-monospace, monospace";

export const section = {
  px: { xs: 2.5, md: 3 },
  pb: { xs: 8, md: 14.75 },
};

export const maxW = "1140px";

// Small caps mono label used above every section heading.
export const eyebrowSx = {
  fontFamily: mono,
  fontSize: "11.5px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: c.purpleDeep,
  mb: 2.5,
};

// Big display heading.
export const h2Sx = {
  fontSize: "clamp(30px, 4.6vw, 58px)",
  lineHeight: 1.04,
  letterSpacing: "-0.035em",
  fontWeight: 600,
  color: c.ink,
  textWrap: "balance",
};

export const cardSx = {
  bgcolor: c.bgSoft,
  border: `1px solid ${c.line}`,
  borderRadius: "24px",
  p: { xs: 3.5, md: 4.25 },
};

export const pillButtonSx = {
  borderRadius: "980px",
  textTransform: "none",
  fontSize: "15px",
  fontWeight: 500,
  px: 3.5,
  py: 1.75,
};
